<template>
  <div>
    <v-tooltip bottom v-if="buttonIcon">
      <v-btn flat icon :color="color" slot="activator" class="jbtn-file">
        <v-icon>{{ icon }}</v-icon>
        <input type="file" v-on:change="fileSelected" />
      </v-btn>
      <span>{{ title }}</span>
    </v-tooltip>
    <v-btn dark block color="primary" slot="activator" class="jbtn-file" v-else>
      {{ title }}
      <v-icon class="pl-2">{{ icon }}</v-icon>
      <input type="file" v-on:change="fileSelected" />
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "upload-button",
  props: {
    selectedCallback: Function,
    title: String,
    icon: {
      type: String,
      required: false,
      default: "cloud_upload"
    },
    color: {
      type: String,
      required: false,
      default: "white"
    },
    buttonIcon: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  methods: {
    fileSelected(e) {
      if (this.selectedCallback) {
        if (e.target.files[0]) {
          this.selectedCallback(e.target.files[0]);
        } else {
          this.selectedCallback(null);
        }
      }
    }
  }
};
</script>

<style scoped>
.jbtn-file {
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.jbtn-file input[type="file"] {
  position: absolute;
  top: 0;
  right: 0;
  min-width: 100%;
  min-height: 100%;
  text-align: right;
  filter: alpha(opacity=0);
  opacity: 0;
  outline: none;
  cursor: inherit;
  display: block;
}
</style>
